import React from 'react';

var OverlayLabel = function (_a) {
    var text = _a.text, onClick = _a.onClick;
    return (React.createElement("button", { onClick: onClick, className: 'pgc-overlay-button' },
        React.createElement("span", { className: 'pgc-overlay-button-text' }, text)));
};

export { OverlayLabel };
